import { arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, string, unknown } from "@altostra/type-validations/lib/primitives";

export const isBrazeMcpTool = objectOf({
  name: string,
  description: string,
  input_schema: recordOf(unknown),
  read_only: boolean,
  destructive: boolean,
  idempotent: boolean,
});

export const isGetAppGroupIdBrazeMcpToolsResult = objectOf({
  tools: arrayOf(isBrazeMcpTool),
});
